import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalHeaderOrderRequestDetail as ModalHeader } from './modal-head.component';
import ModalBodyOrderRequestDetail, { NewRequestModalBody, ModalTextBody, ModalRejectBody } from './modal-body.component';
import { ModalFooterExhibit1 as ModalFooter1, ConfirmationModalFooter } from './modal-footer.component';
import { SuccessMessage, FailMessage } from '../../common/success-message/success-messaage.component';
import Translation from "../../common/translation/translation.component";
import { NoSubscription } from '../../external/dashboard/no-subscription/no-subscription.component';
import { OTHER_MENU_FILTER, REQUEST_TYPES_ID, GET_REQUEST_HEADER_TITLE, INTERNATIONAL_REQUEST_FILTER, REQUEST_TYPE } from "../../../constants/external-constants";
import { NotificationModal } from "../../common/modal/notification-modal.component";

import './modal.component.css';

export class RequestDetailModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            hideModal: false
        }
    }

    async componentDidMount() {
        this.handleShow();
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    handleClose = () => {
        const { hasCloseAction, closeAction } = this.props;

        if (hasCloseAction) {
            closeAction();
        }

        this.setState({
            show: false
        });
    }

    modifyModalTitle = (title) => {
     
        const result = OTHER_MENU_FILTER.find(obj => obj.Value === title)
        const result_roamingaAccess = INTERNATIONAL_REQUEST_FILTER.find(obj => obj.Value === title)
        
        if(this.props.isQuotationRequest) return title;
        if (result != null) {
            return `Other - ${result.Value} Request`
        }
        if (result_roamingaAccess != null) {
            return `International Access - ${result_roamingaAccess.Value} Request`
        } else {
            return `${title} Request`
        }
    }

    setOrderStatusId = (Id) => {
        const { orderStatusId } = this.props
        return orderStatusId === 0 ? Id : orderStatusId;
    }

    render() {
        const { title , id   
            //data props
            , data
            , milestone
            , activities
            , comments
            , approverData
            , approverWorkFlowData
            //bool props
            , isLoaded
            , isOtherRequest
            , isQuotationRequest
            , isApproverLoaded
            , canCancelOrder
            , canHandleRequest
            //actions props
            , handleApprovalClick
            , handleRejectionClick
            , showConfirmationModal
            , showRejectConfirmationModal
            , handleCancelRejectionClick
            , showRejectionCommentBox
            , showDecisionButtons
            , status
            , statusData
            , selectedItem
        } = this.props;
        return (
            <div>
                <Modal
                    id={id}
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                    dialogClassName="modal-dialog-container modal-details-view"
                >
                    <ModalHeader title={this.modifyModalTitle(title)}
                        status={this.setOrderStatusId(selectedItem.OrderStatusId)}
                        statusData={statusData} />
                    {
                        isLoaded ? <ModalBodyOrderRequestDetail
                            history={this.props.history}
                            data={data}
                            selectedItem={selectedItem}
                            approverData={approverData}
                            approverWorkFlowData={approverWorkFlowData}
                            isApproverLoaded={isApproverLoaded}
                            milestone={milestone}
                            activities={activities}
                            comments={comments}
                            isOtherRequest={isOtherRequest}
                            isQuotationRequest={isQuotationRequest}
                            showConfirmationModal={showConfirmationModal}
                            status={statusData}
                            canCancelOrder={canCancelOrder}
                            canHandleRequest = {canHandleRequest}
                            closeAction={this.handleClose}
                        /> :
                            <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                    }
                    {/* <ModalFooter1
                        closeAction={this.handleClose}
                        approveAction={handleApprovalClick}
                        handleRejectionClick={handleRejectionClick}
                        handleCancelRejectionClick={handleCancelRejectionClick}
                        showConfirmationModal={showConfirmationModal}
                        showRejectConfirmationModal={showRejectConfirmationModal}
                        showRejectionCommentBox={showRejectionCommentBox}
                        showDecisionButtons={showDecisionButtons}
                        data={data}
                        canCancelOrder={canCancelOrder}
                    /> */}
                </Modal>
            </div>
        );
    }
};

export class RequestModal extends Component {

    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            show: false,
            requestType: "",
            requestTypeId: 0,
            successModalMessage: false,
            successMessage: "",
            failModalMessage: false,
            failMessage: "",
            hideRequestModal: false,
            disableAutoScroll: false,
            path: window.location.pathname,
            noticeNotif: {
                show: false,
                title: "",
                message: "",
                subMessage: ""
            },
        }
    }

    componentDidMount() {
        if (this.props.requestTypeId == REQUEST_TYPES_ID.portIn) {
            this.toggleNoticeNotif(true,
                <Translation translationKey="notice_title" />,
                <Translation translationKey="port_in_notice_message" />,
                <Translation translationKey="port_in_notice_sub" />);
        }
        this.setState ({
            path: window.location.pathname        
        });
    }

    handleShow = (requestTypeId, requestType) => {
        this.setState({
            show: true,
            requestType: requestType,
            requestTypeId: requestTypeId
        });
    }
    
    showConfirmationModal = e => {
        this.ConfirmationModal.current.handleShow();
    };

    handleClose = () => {
        this.showConfirmationModal();
        //this.setState({
        //    show: false
        //});

        //if (closeAction !== undefined && closeAction !== null) {
        //    closeAction();
        //}
    }
    handleConfirm = () => {
        const { closeAction } = this.props;
        this.showConfirmationModal();
        this.setState({
            show: false
        });

        if (closeAction !== undefined && closeAction !== null) {
            closeAction();
        }
    }
    closeModal=() =>{
        const { closeAction } = this.props;
        this.setState({
            show: false
        });

        if (closeAction !== undefined && closeAction !== null) {
            closeAction();
        }
    }
    messageModal = (res) => {

        const { closeAction } = this.props;

        if (res.Success) {

            this.setState({
                successModalMessage: true
                , show: false
                , successMessage: res.Message
            });
            setTimeout(function () {
                this.setState({
                    successModalMessage: false
                });

                if (closeAction !== undefined && closeAction !== null) {
                    closeAction();
                }

            }.bind(this), 2000);

        } else {
            //document.getElementsByClassName("fade modal-backdrop show")[0].style.opacity = "0";
            this.setState({
                failModalMessage: true
                , failMessage: res.Message
            });
            setTimeout(function () {
                //document.getElementsByClassName("fade modal-backdrop show")[0].style.opacity = "0.5";
                this.setState({
                    failModalMessage: false
                });

            }.bind(this), 2000);
        }
    }

    handleCloseNotif = () => {
        this.toggleNoticeNotif(false)
    }

    headerTitle = (requestTypeId) => {
        let requestTitle = requestTypeId === undefined && requestTypeId === null ? null : GET_REQUEST_HEADER_TITLE.filter(x => x.Key === requestTypeId);
        if (requestTypeId == REQUEST_TYPES_ID.intlRoamingAccess) {
            if (this.state.path.includes("Update")) {
                return ` ${REQUEST_TYPE.InternationalAccess} - Roaming Access Request`;
            } else {
                return requestTitle !== undefined &&
                    requestTitle !== null &&
                    requestTitle.length > 0
                    ? requestTitle[0].Value
                    : "";
            }
        } else if(requestTypeId == REQUEST_TYPES_ID.CallingAccess) {
            if (this.state.path.includes("Update")) {
                return `${REQUEST_TYPE.InternationalAccess } - Calling Access Request`;
            } else {
                return requestTitle !== undefined &&
                    requestTitle !== null &&
                    requestTitle.length > 0
                    ? requestTitle[0].Value
                    : "";
            }
        } else {
            return requestTitle !== undefined &&
                requestTitle !== null &&
                requestTitle.length > 0
                ? requestTitle[0].Value
                : "";
               }       
    }

    toggleNoticeNotif = (isShow, title, message, subMessage) => {
        const { noticeNotif } = this.state;
        this.setState({
            noticeNotif: {
                ...noticeNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
                subMessage: subMessage ?? ""
            }
        });
    }

    hideRequestModal = ()=>{
        this.setState({hideRequestModal:true})
    }

    disableAutoScroll = (value) =>{
        this.setState({disableAutoScroll:value})
    }

    render() {
        const { successMessage, failMessage, disableAutoScroll } = this.state;
        const { data, requestTypeId, requestType } = this.props;
        return (
            <div>
                {this.state.successModalMessage &&
                    <SuccessMessage message={successMessage}/>
                }
                {
                    this.state.noticeNotif.show && requestTypeId == REQUEST_TYPES_ID.portIn ?
                    <NotificationModal
                        show={this.state.noticeNotif.show}
                        title={this.state.noticeNotif.title}
                        message={this.state.noticeNotif.message}
                        subMessage={this.state.noticeNotif.subMessage}
                        handleModal={this.handleCloseNotif}
                        customClass={'comment-notification-modal notification-footer'}
                        closeButton={false}
                    />
                    : 
                    <>
                        <Modal
                            id={"request-result-modal"}
                            show={this.state.show}
                            onHide={this.showConfirmationModal}
                            backdrop="static"
                            keyboard={false}
                            dialogClassName={`modal-dialog-container modal-mw-50 ${disableAutoScroll && "disable-auto-scroll"} ${this.state.hideRequestModal ? "opacity-0" : ""} ${this.state.failModalMessage ? "error-modal" : ""}`}
                        >
                            {this.state.failModalMessage &&
                                <FailMessage message={failMessage} />
                            }
                            <ModalHeader title={this.headerTitle(requestTypeId)} />
                            <NewRequestModalBody 
                                disableAutoScroll={this.disableAutoScroll.bind(this)}   
                                hideRequestModal={this.hideRequestModal.bind(this)} 
                                data={data} 
                                isLoaded={true} 
                                typeId={requestTypeId} 
                                modalMessage={this.messageModal} 
                                modalClose={this.handleClose} 
                                closeAction={this.closeModal}
                            />
                        </Modal>

                        <ConfirmationModal
                            ref={this.ConfirmationModal}
                            title={<Translation translationKey="discard_form" />}
                            messageBody={<Translation translationKey="are_you_sure_you_want_to_discard_this_request" />}
                            confirmAction={this.handleConfirm}
                            closeLabel={<Translation translationKey="discard_cancelBtn" />}
                            confirmLabel={<Translation translationKey="discard_confirmBtn" />}
                        />
                    </>
                }
                
            </div>
        );
    }
};


export class ConfirmationModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    handleClose = () => {
        const { closeAction, setInprogress } = this.props;

        if (typeof setInprogress === 'function') {
            setInprogress(false);
        }

        this.setState({
            show: false
        });
     
        if (closeAction !== undefined && closeAction !== null) {
            closeAction();
        }
    }

    render() {
        const { title, messageBody, confirmAction, closeLabel, confirmLabel, disabled, isUpdate, customClass } = this.props;
        return (
            <div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                    className={`${isUpdate && "modal-large-confirmation"} ${customClass} confirmation-blur-background modal-text-bold custom-column-modal-container confirmation-modal-container`}
                    contentClassName={"mw-0"}
                >
                    <ModalHeader title={title} />                    
                        <ModalTextBody messageBody={messageBody} />                                      
                    <ConfirmationModalFooter
                        closeAction={this.handleClose}
                        confirmAction={confirmAction}
                        closeLabel={closeLabel}
                        confirmLabel={confirmLabel}
                        disabled={disabled}
                        />
                </Modal>
            </div>
        );
    }
};


export class RejectConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
            , rejectReason: ''
        }
    }

    onChangeRejectReason = (e) => {

        this.setState({
            rejectReason: e.target.value
        });

    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    handleClose = () => {
        const { closeAction } = this.props;

        this.setState({
            show: false
            , rejectReason: ""
        });

        if (closeAction !== undefined && closeAction !== null) {
            closeAction();
        }
    }

    render() {
        const { title, messageBody, confirmAction, closeLabel, confirmLabel } = this.props;
        return (
            <div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                    className={"confirmation-blur-background"}
                    contentClassName={"mw-0"}
                >
                    <ModalHeader title={title} />
                    <ModalRejectBody messageBody={messageBody} rejectReason={this.state.rejectReason} onChangeAction={this.onChangeRejectReason} />
                    <ConfirmationModalFooter closeAction={this.handleClose}
                        confirmAction={confirmAction}
                        disabled={this.state.rejectReason === ''}
                        closeLabel={closeLabel}
                        confirmLabel={confirmLabel}
                    />
                </Modal>
            </div>
        );
    }
}